export const TOTALS_TEST_IDS = {
  total: 'total',
  subtotal: 'subtotal',
  taxAmount: 'tax-amount',
  surcharge: 'surcharge',
  variableAmount: 'variable-amount',
  tip: 'tip',
  convenienceFee:'convenience-fee'
};

export const MIN_VARIABLE_AMOUNT = 1;
export const MAX_VARIABLE_AMOUNT = 999_999_99;
